/// <reference path="../../typings/globals/jquery/index.d.ts" />
/// <reference path="module/accordion.ts"/>
/// <reference path="module/checkbox.ts"/>
/// <reference path="module/delete.ts"/>
/// <reference path="module/inquiry.ts"/>
/// <reference path="module/modal.ts"/>
/// <reference path="module/modal_scrollbar.ts"/>
/// <reference path="module/page_index.ts"/>
/// <reference path="module/page_job_search_result.ts"/>
/// <reference path="module/pref_ajax.ts"/>
/// <reference path="module/smooth_scroll.ts"/>
/// <reference path="module/switch_tab.ts"/>

interface callbackType{(argv?: number): void};

const win     : JQuery = $(window),
	body      : JQuery = $("body"),
	searchBox : JQuery = $(".c-searchbox"),
	submitBtn : JQuery = searchBox.find("[type=\"submit\"], [data-form=\"submit-btn\"]");

/*--------------------------------------------------------------------------

  Controller

--------------------------------------------------------------------------*/
/*--------------------------------------------------------------------------*
 * アコーディオン（検索BOX）
 *--------------------------------------------------------------------------*/
module Controller_Acd {
	import Model_Acd = Module_Acd.Model_Acd;
	import Model_MdlScrlbar = Module_MdlScrlbar.Model_MdlScrlbar;

	export function run(): void {
		const model: Model_Acd = new Model_Acd(),
			mdlScrlbar: Model_MdlScrlbar = new Model_MdlScrlbar(null);

		// 初期設定
		model.tab.each(function(): void {
			const _self: JQuery = $(this);
			if(_self.attr("aria-selected") === "false") {
				$("#"+_self.attr("aria-describedby")).hide();
			}
		});

		// 選択済みの都道府県がある場合、初期表示する
		const defaultTabVal: string = $("#_modal_first_prefecture_id").val();
		if(defaultTabVal) {
			const defaultTabParentId: string = $('[data-switch="tab"][value="'+defaultTabVal+'"]').parents('[data-acd="panel"]').attr("id"),
				parentTab: JQuery = $('[data-acd="tab"][aria-describedby="'+defaultTabParentId+'"]');
			model.moveAcdPnl(parentTab, true);
		}

		// トリガーをクリックしたとき
		model.tab.on("click", function(): void {
			const _self: JQuery = $(this);
			model.moveAcdPnl($(this), false, function(): void {
				if(_self.parents('[data-modal="panel"]').length) {
					mdlScrlbar.changeScrlBarProp();
				}
			});
		});
	}
}


/*--------------------------------------------------------------------------*
 * チェックボックス
 *--------------------------------------------------------------------------*/
module Controller_Checkbox {
	import Model_Checkbox = Module_Checkbox.Model_Checkbox;

	export function run() {
		const model:Model_Checkbox = new Model_Checkbox();

		// チェックしたとき実行
		$(document).on("click", '[data-check="parent"], [data-check="child"]', function(): void {
			const _self: JQuery = $(this);
			switch(_self.data("check")) {
				case "parent":
					model.changeChildProp($(this));
					break;
				case "child":
					model.changePrntProp($(this));
					break;
			}
		});
	}
}


/*--------------------------------------------------------------------------*
 * 検索条件削除
 *--------------------------------------------------------------------------*/
module Controller_Delete {
	import Model_Delete = Module_Delete.Model_Delete

	export function run(): void {
		const model: Model_Delete = new Model_Delete(),
			resetBtn: JQuery = $("[data-reset=\"btn\"]")

		resetBtn.on("click", function(): void {
			const _self: JQuery = $(this),
				mdl: JQuery = _self.parents("[data-modal=\"panel\"]")
			model.resetInput(mdl)
		});
	}
}


/*--------------------------------------------------------------------------*
 * 検索条件削除
 *--------------------------------------------------------------------------*/
module Controller_Inquiry {
	import Model_Inquiry = Module_Inquiry.Model_Inquiry;

	export function run(): void {
		const model: Model_Inquiry = new Model_Inquiry(),
			form     = $('#form'),
			inputs   = form.find('input, textarea'),
			btn      = form.find('button[name="__submit__"]'),
			config_arr = [
				// お名前
				{
					type : 'text',
					name : 'name',
				},
				// 電話番号
				{
					type : 'text',
					name : 'tell',
				},
				// メールアドレス
				{
					type : 'text',
					name : 'email',
				},
				// お問い合わせ内容
				{
					type : 'textarea',
					name : 'message',
				}
			];

		// 読み込み時に発火
		model.change_btn_prop(btn, config_arr);

		// 値を変更したときに発火
		inputs.on('change', (): void => {
			model.change_btn_prop(btn, config_arr);
		});
	}
}


/*--------------------------------------------------------------------------*
 * モーダル
 *--------------------------------------------------------------------------*/
module Controller_Modal {
	import Model_Modal = Module_Modal.Model_Modal;
	import Model_MdlScrlbar = Module_MdlScrlbar.Model_MdlScrlbar;

	class inputProp implements inputProp {
		name: string;
		type: string;
		prop?: string|boolean[];
	}

	class idProp implements idProp {
		id: string;
		prop: boolean;
	}

	export function run(): void {
		const model: Model_Modal = new Model_Modal(),
			mdlScrlbar: Model_MdlScrlbar = new Model_MdlScrlbar();

		let checkedRadiusArr: idProp[] = [],
			checkedAreaArr: idProp[] = [],
			checkOtherArr: inputProp[] = [],
			scrlTop: number;

		// 開くボタンをクリックしたとき
		model.tab.on("click", function(): void {
			scrlTop = win.scrollTop(); // scrlTopの更新
			model.modalOpen($(this), scrlTop, function(): void {
				mdlScrlbar.changeScrlBarProp(); // スクロールバーの表示設定実行
			}); // モーダルを開く
			checkedRadiusArr = model.saveRadiusList(); // 現在地からの距離を一時保存
			checkedAreaArr = model.saveAreaList(); // 勤務地を一時保存
			checkOtherArr = model.saveOtherList(); // 詳細条件を一時保存
		});

		// 閉じるボタンをクリックしたとき
		model.clsBtn.on("click", function(): void {
			const _self = $(this);

			// 設定ボタンのとき
			if(_self.attr("data-form") === "submit-btn") {
				model.setAreaList(); // 選択した勤務地をセット
			} else {
				// model.resetRadiusList(checkedRadiusArr); // 現在地からの距離をリセット
				// model.resetAreaList(checkedAreaArr); // 勤務地をリセット
				// model.resetOtherList(checkOtherArr); // 詳細条件をリセット
			}
			mdlScrlbar.changeScrlBarPropInit(); // スクロールバーの表示設定初期化
			model.modalClose(_self, scrlTop); // モーダルを閉じる
		});

		// windowサイズが変更されたとき
		win.on("resize", (): void => {
			if($('[data-modal="wrapper"]').attr("aria-hidden") === "true") return;
			model.setAreaList(); // 選択した勤務地をセット
			model.modalClose(model.clsBtn, scrlTop); // モーダルを閉じる
			mdlScrlbar.changeScrlBarPropInit(); // スクロールバーの表示設定初期化
		});
	}
}


/*--------------------------------------------------------------------------*
 * スクロールバーの出し分け
 *--------------------------------------------------------------------------*/
module Controller_MdlScrlBar {
	import Model_MdlScrlbar = Module_MdlScrlbar.Model_MdlScrlbar;

	export function run(): void {
		const model: Model_MdlScrlbar = new Model_MdlScrlbar(null);

		// 初期化
		model.changeScrlBarPropInit();
	}
}


/*--------------------------------------------------------------------------*
 * TOPページ
 *--------------------------------------------------------------------------*/
module Controller_Index {
	import Model_Index = Module_Index.Model_Index;

	export function run(): void {
		// トップページ以外実行しない
		if(!body.hasClass("p-index")) return;

		const model: Model_Index = new Model_Index()

		// 検索パネルのエリア位置調整
		model.ajustIndexAreaList();

		// 新着求人の整形
		model.newJobConfig();
	}
}


/*--------------------------------------------------------------------------*
 * 求人一覧ページ
 *--------------------------------------------------------------------------*/
module Controller_JobSearchResult {
	import Model_JobSearchResult = Module_JobSearchResult.Model_JobSearchResult;

	export function run(): void {
		// 検索結果以外実行しない
		if(!body.hasClass("p-job_search_result")) return;

		const model = new Model_JobSearchResult();

		// mainがサイドバーより短いとき高さを合わせる
		model.resizeMain($(".l-main"), $(".c-side--search"), null);
	}
}


/*--------------------------------------------------------------------------*
 * 市区町村パネルの取得
 *--------------------------------------------------------------------------*/
module Controller_PrefAjax {
	import Model_PrefAjax = Module_PrefAjax.Model_PrefAjax;

	enum Mode {
		Pc = "pc",
		Sp = "sp"
	}

	export function run(): void {
		$(window).on("load", function() {
			const model: Model_PrefAjax = new Model_PrefAjax(),
				switchTab = $('.c-area_list [name="pref_id[]"]');

			if(!switchTab.length) return;

			switchTab.each(function() {
				const _self = $(this),
					pref_id = _self.val(),
					pearPnl = $('#prefPnl'+pref_id);

				// すでにパネルの中身が存在する場合は実行しない
				if(pearPnl.find('.c-parent_check').length || pearPnl.find('.c-searchbox__checkbox').length) {
					return;
				}

				model.makePanel(pref_id, Mode.Pc).done(function(result: JQueryXHR): void {
					pearPnl.html(String(result));
				});
			});
		});
	}
}


/*--------------------------------------------------------------------------*
 * slick
 *--------------------------------------------------------------------------*/
module Controller_Slick {
	export function run(): void {
		// orverflowを提要する要素
		const slider: JQuery = $(".c-slider01");

		// sliderがないとき実行しない
		if (!slider.length) return;

		const ofEml: JQuery = slider.find(".c-hdg05 a, .c-order_detail__desc--line02[data-type=\"location\"], .c-order_detail__desc[data-type=\"job_type\"]");

		const init = slider
			.on("init", function(): void { // slickコールバック
				ofEml.css({ overflow: "hidden" });
			})
			.slick({ // slickを開始
				dots: true,
				prevArrow: "<button type=\"button\" class=\"slick-prev\"></button>",
				nextArrow: "<button type=\"button\" class=\"slick-next\"></button>",
				adaptiveHeight: true,
			});

		// slickを初期化
		win.on("resize", function(): void {
			init.slick("setPosition");
		});
	}
}

/*--------------------------------------------------------------------------*
 * SMOOTH SCROLL
 *--------------------------------------------------------------------------*/
module Controller_SmoothScroll {
	import Model_SmoothScroll = Module_SmoothScroll.Model_SmoothScroll;

	export function run(): void {
		const trg: JQuery = $('a[href^="#"], #map path'),
			model: Model_SmoothScroll = new Model_SmoothScroll(),
			hash: string = location.hash;

		trg.on("click", function(): boolean {
			const _self: JQuery = $(this),
				href: string = _self.attr("href");
			model.run(href);
			return false;
		});

		if(hash) {
			model.run(hash, false);
		}
	}
}


/*--------------------------------------------------------------------------*
 * タブ
 *--------------------------------------------------------------------------*/
module Controller_SwitchTab {
	import Model_SwitchTab = Module_SwitchTab.Model_SwitchTab;
	import Model_MdlScrlbar = Module_MdlScrlbar.Model_MdlScrlbar;

	export function run(): void {
		const model: Model_SwitchTab = new Model_SwitchTab(),
			mdlScrlbar: Model_MdlScrlbar = new Model_MdlScrlbar(null);

		// イベント登録
		$(document).on("click", '[data-switch="tab"]', function(): void {
			const _self: JQuery = $(this);
			model.switchPnl(_self, function(): void {
				mdlScrlbar.changeScrlBarProp();
			});
		});

		// モーダルを開いたタイミングで、タブの切替
		$(document).on("click", '[data-modal="tab"]', function(): void {
			const _self: JQuery = $(this);
			model.switchPnl($('.c-switch_list [data-type="'+_self.attr("data-type")+'"]'));
		});

		// 選択済みの都道府県がある場合、初期表示する
		const defaultTabVal: JQuery = $("#_modal_first_prefecture_id").val();
		if(defaultTabVal) {
			const defaultTab: JQuery = $('[data-switch="tab"][value="'+defaultTabVal+'"]');
			model.switchPnl(defaultTab, function(): void {
				mdlScrlbar.changeScrlBarProp();
			});
		}
	}
}

/*--------------------------------------------------------------------------*
 * 実行
 *--------------------------------------------------------------------------*/
module init {
	export function run():void {
		Controller_Acd.run();
		// Controller_Checkbox.run();
		// Controller_Delete.run();
		Controller_Inquiry.run();
		// Controller_Modal.run();
		Controller_MdlScrlBar.run();
		Controller_Index.run();
		Controller_JobSearchResult.run();
		// Controller_PrefAjax.run();
		Controller_Slick.run();
		Controller_SmoothScroll.run();
		Controller_SwitchTab.run();
	}
}

// 関数をセット
$(init.run);
